import { getAxiosConfig } from "@/services/axiosConfig";
import { IBrands, IBrandsGeneric } from "global-types/global.types";
import { useQuery } from "react-query";

function useBrands(slug: string[]) {
  const { data: brands, isLoading: isLoadingBrands } = useQuery(
    ["BRANDS", slug],
    async () => {
      if (!slug) return null;

      const res = await getAxiosConfig().get<IBrands<IBrandsGeneric[]>>(
        `/brand?category=${slug}`
      );

      return res.data;
    }
  );

  return {
    brands,
    isLoadingBrands,
  };
}

export default useBrands;
